<template>
  <div>
    <operation-list-filter
      :operationTypes="operationTypes"
      @operationTypeChanged="onOperationTypeChanged" />
    <br />
    <br />

    <div v-if="!loading" :class="{ 'not-active': !paramsComplete }">
      <operation-list-item
        v-for="op in operations" :key="op.id"
        v-show="isOperationVisible(op)"
        :operation="op"
        v-on:click.native="onItemClicked(op)" />
    </div>
  </div>
</template>

<script>
  import OperationListItem from './OperationListItem'
  import OperationListFilter from './OperationListFilter'
  import productService from '../api/productService'

  export default {
    props: [
      'operationTypes',
      'paramsComplete',
      'category'
    ],

    data() {
      return {
        operations: [],
        loading: false,
        activeType: null
      }
    },

    methods: {
      onOperationTypeChanged(operationType) {
        this.activeType = operationType
        this.$emit('operationTypeChanged', operationType)
      },

      isOperationVisible(operation) {
        if(this.activeType) {
          return this.activeType.slots.includes(operation.slot)
        }
        return operation.slot.indexOf(this.category) === 0;
      },

      loadOperations() {
        this.loading = true

        productService.listOperations()
          .then(operations => {
            this.operations = operations
            this.loading = false
          });
      },

      onItemClicked(operation) {
        if(this.paramsComplete) {
          this.$emit('operationSelected', operation)
        }
        else {
          this.showDialog();
        }
      },

      showDialog() {
        this.$router.push({ path: 'kesken', append:true })
      }
    },

    mounted() {
      this.loadOperations()
    },

    components: {
      OperationListItem,
      OperationListFilter
    }
  }
</script>

<style scoped>
  .not-active {
    opacity: 0.5;
  }
</style>



// WEBPACK FOOTER //
// src/components/OperationList.vue